import { useState, useEffect } from "react";
import "./ResponseContentRating.css";
import { Question } from "effno-core";
import { useSelector } from "react-redux";
import { selectUIStates } from "../../redux/features/appData";
import { ResponseNavigate } from "./ResponseNavigate";
import { RatingResponse } from "../config/responseSettings";
import config from "environment";
import { RatingStar } from "../shared/RatingStar";
import { ResponseErrors } from "./responseErrors";
import { isMobile } from "../../utils/screens";
import { NEXT_BUTTON } from "./ResponseContent";
import { TriangleAlert } from "lucide-react";

const debugMode = config.debugMode;

type ResponseContentRatingProps = {
    question: Question;
    responseValues: string;
    isPreview: boolean;
    isMobileLayout: boolean;
    isLastQuestion: boolean;
    commentMode: boolean;
    onNext?: () => void;
    onPrev?: () => void;
    onSubmit: (responseValues: string) => void;
}

export const ResponseContentRating = ({
    question,
    responseValues,
    isPreview,
    isMobileLayout,
    isLastQuestion,
    commentMode,
    onNext,
    onPrev,
    onSubmit
} : ResponseContentRatingProps) => {

    // const uiStates = useSelector(selectUIStates);

    const [title, setTitle] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [score, setScore] = useState<number | undefined>(undefined);
    const [error, setError] = useState<string>("");

    useEffect(() => {
        setTitle(question.title);
        setDescription(question.description);
        setScore(JSON.parse(responseValues).score || undefined);
        setError(ResponseErrors.none);
    }, [question, responseValues])

    const metRequirements = (theScore: number | undefined) : "ok" | "required" => {

        if (!question.required || (theScore !== undefined)) {
            return "ok";
        }

        if (question.required && (theScore === undefined)) {
            return "required";
        }

        return "ok"
    }

    const handleNext = () => {
        if (isPreview && onNext) {
            onNext();
        } else {
            handleSubmit();
        }
    }

    const handleSubmit = () => {

        const met = metRequirements(score);

        if (met === "required") {
            setError(ResponseErrors.required);
            return;
        }

       saveResponse(score)
    }

    const saveResponse = (theScore: number | undefined) => {
        const newResponseValues: string = JSON.stringify({
            score: theScore
        } as RatingResponse);

        onSubmit(newResponseValues);
    }

    const handleScoreChange = (newScore: number) => {
        setScore(newScore);
        saveResponse(newScore);
    }

    const requirementsMet = metRequirements(score) === "ok";

    const settings = JSON.parse(question.settings);

    const min = 1;
    const max = parseInt(settings.stars) || 5; 

    const scoreArray : string [] = [];
    for (let i = min; i <= max; i++) {
        scoreArray.push(i.toString());
    }

    const mobileLayout = isMobileLayout || isMobile(); 

    console.log("[ResponseContentRating] question: ", question);
    console.log("[ResponseContentRating] min: ", min);
    console.log("[ResponseContentRating] max: ", max);
    console.log("[ResponseContentRating] mobileLayout: ", mobileLayout);


    return (
        <div className="form-content-body">
{/* 
            {debugMode && question &&
                <div className="response-content-question-id">
                    {question.id}
                </div>
            }
                         */}
            
            <div 
                className="response-content-title"
                data-testid={"response-content-title:" + title}
            >
                {title}
            </div>
            
            <div className="response-content-description">
               {description}
            </div>   

            <div className="form-content-score" style={{marginTop: "40px"}} >
                <div className="response-content-ratings">
                    {scoreArray.map((theScore: string) => {
                        return (
                            <div 
                                className={(mobileLayout && scoreArray.length > 7) ? 
                                    "response-content-star-compact" : "form-content-star"
                                }
                                key={"star-" + theScore}
                                onClick={(e: any) => handleScoreChange(Number(theScore))}
                                data-testid={"response-content-score#" + theScore}
                            >
                                <RatingStar
                                    starNumber={Number(theScore)}
                                    starCount={scoreArray.length}
                                    isMobileLayout={mobileLayout}
                                    highlight={parseInt(theScore) === score}
                                />
                            </div>
                        )
                    })}
                </div>
            </div>    

            <div 
                className="response-content-error"
                style={!error ? {backgroundColor: "transparent"} : {}}
                data-testid="response-content-error"
            >
                {error && <TriangleAlert size={16}/>}{error}
            </div>

            {/* <div className="response-content-submit">
                <button
                    className="response-content-button-submit"
                    onClick={handleSubmit}
                    data-testid="response-content-submit"
                >
                    {onNext ? NEXT_BUTTON : "Submit"}
                </button>
            </div> */}

            <ResponseNavigate 
                isMobileLayout={isMobileLayout}
                isLastQuestion={isLastQuestion}
                commentMode={commentMode}
                onSubmit={handleSubmit}
                onNext={handleNext}
                onPrev={onPrev}
            />

        </div>
    )
}